// src/components/OptionBatchBubble.js
import React from 'react';
import ChatMessage from './ChatMessage.js';

/**
 * props.data: {
 *   optionSetId: number,
 *   options: Array<{
 *     id: number,
 *     idx: number,
 *     html: string,
 *     css: string,
 *     js: string,
 *     raw_text: string
 *   }>
 * }
 */
export default function OptionBatchBubble({
  data,
  optionState,
  jumpToOption,
  setAcceptedId,
  appendOptionAsVersion,
  isOwner
}) {

  // If one option was already accepted, disable all buttons
  const isAccepted = optionState?.status === 'accepted';
  const showDirections = optionState?.status === 'pending';
  const canInteract   = isOwner && !isAccepted;   // <- only owners may click

  /* helper inside the bubble ------------------------------------------- */
  const buttons = data.options.map((o, i) => {
    const isChosen = optionState?.acceptedId === o.id;
    const isHovered  = optionState?.hoveredId  === o.id;          // previewed 👁
    const isActive   = isChosen || (isHovered && !isAccepted);    // highlight if active

    // console.log("[OptionBatchBubble] render, optionState =", optionState);
    return (
      <button
        key={o.id}
        onMouseEnter={() => {
          console.log(`[OptionBatchBubble] onMouseEnter: idx=${i}, option.id=${o.id}`);
          console.log("[OptionBatchBubble] data.options:", data.options.map(x => x.id));
          console.log(`[OptionBatchBubble] calling jumpToOption(${i})`);
          jumpToOption(i);
        }}
        disabled={isAccepted}
        onClick={async () => {
          if (!canInteract) return;
          /** update local history so the dropdown shows “Version 1” immediately */
          appendOptionAsVersion(o.idx);   // idx is 0 / 1 / 2
        }}
        style={{
          fontSize: '1em',
          padding: '6px 12px',
          border : isChosen
                    ? '2px solid #4caf50'       // green border if chosen
                    : isActive
                      ? '2px solid #2196f3'     // blue border if merely hovered
                      : '1px solid #ccc',
          background: isChosen
                        ? '#e8f5e9'             // pale green fill if chosen
                        : isActive
                          ? '#e3f2fd'           // pale blue fill if hovered
                          : 'white',
          cursor: canInteract ? 'pointer' : 'default'
        }}
      >
        {/* label “Option A / B / C” based on idx (or use i directly) */}
        Option {String.fromCharCode(65 + o.idx)}
      </button>
    );
  });

  /* build one node containing directions (optional) + buttons */
  const bubbleContent = (
    <div
      style={{
        background: '#f9f9f9',   /* light card tint */
        border:     '1px solid #ddd',
        borderRadius: 6,
        padding:    8,
      }}
    >
      {showDirections && (
        <div
          style={{
            marginBottom: 6,
            fontSize: '0.9em',
            color: '#666',
            fontStyle: 'italic',
          }}
        >
          Pick an option to continue
        </div>
      )}
      <div style={{ display: 'flex', gap: 8 }}>{buttons}</div>
    </div>
  );

  /* render as a normal AI chat-bubble */
  return <ChatMessage sender="ai" text={bubbleContent} />;
}
